import { render, staticRenderFns } from "./WhitelabelPageContainer.vue?vue&type=template&id=3379852c&"
import script from "./WhitelabelPageContainer.vue?vue&type=script&lang=js&"
export * from "./WhitelabelPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports